var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createStore } from '../../util/createStore';
var useStore = createStore({}).useStore;
function getInitialState() {
    return {
        isSidebarOpen: false,
    };
}
export function useLayout(layoutId) {
    var _a = useStore(), state = _a[0], setState = _a[1];
    var layoutState = state[layoutId] || getInitialState();
    return __assign(__assign({}, layoutState), { toggleIsSidebarOpen: function (isSidebarOpen) {
            setState(function (state) {
                state[layoutId] = state[layoutId] || getInitialState();
                var layoutState = state[layoutId];
                layoutState.isSidebarOpen = isSidebarOpen !== null && isSidebarOpen !== void 0 ? isSidebarOpen : !layoutState.isSidebarOpen;
            });
        } });
}
